import { ERROR_CODE_401, ERROR_CODE_404, ERROR_CODE_400 } from "manifest-bridge-core/src/errors";
import { ErrorCode } from "../typings";

export type GenerateErrorMessageParams = {
  errorCode: ErrorCode;
  params?: string;
};
const generateErrorMessage = ({ errorCode, params }: GenerateErrorMessageParams): string => {
  switch (errorCode) {
    case ERROR_CODE_400:
      return `Please pass ${params || ""} to launch Bridge`;
    case ERROR_CODE_401:
      return `Invalid accessToken or/and clientId`;
    case ERROR_CODE_404:
      return `Invalid ${params || "reference"}`;
    default:
      return "Unknown Error";
  }
};

export default generateErrorMessage;
